import * as service from "../service";
import { store } from "../../store";
import type { ServiceResponse } from "../types";

type DeleteBusinessCouponPayload = {
  coupon_id: string;
};

type BusinessDeletedCoupon = Record<string, any>;

/**
 * Soft-delete a coupon created by the currently logged-in business user.
 * Backend: POST /api/coupon/businessCoupons/deleteCoupon
 */
export const DeleteBusinessCouponAPI = async (
  payload: DeleteBusinessCouponPayload,
): Promise<ServiceResponse<BusinessDeletedCoupon>> => {
  const { business } = store.getState().auth as any;
  try {
    const resp = (await service.call(
      "POST",
      "api/coupon/businessCoupons/deleteCoupon",
      {
        user_id: business?.user_id,
        ...payload,
      },
    )) as ServiceResponse<BusinessDeletedCoupon>;
    return resp;
  } catch (err) {
    console.error(`DeleteBusinessCouponAPI ${err}`);
    return { status: -1, error: err };
  }
};
